import React from 'react';

import { AppRoutes } from '@/App/AppRoutes/AppRoutes';
import { appRoutesConfig } from '@/App/AppRoutes/appRoutesConfig';
import { withTranslations } from '@/features/i18n/withTranslations';

const AppRoutesBase = () => <AppRoutes routes={appRoutesConfig} />;

export const AppRoutesWrapper = withTranslations(AppRoutesBase);
